import { UserMembershipSchema } from '../schemas';

import { axiosSecure, handleError, handleResponse, RequestResponse } from './config';

export const redeemReferralReward = async (membershipId: string): Promise<RequestResponse> => {
   return await axiosSecure
      .get('/memberships/redeem-referral', { params: { membershipId } })
      .then((response) => handleResponse(response, UserMembershipSchema))
      .catch(handleError);
};
